import { render } from "./EtatProduitsEntreePage.vue?vue&type=template&id=32cf8f68&ts=true"
import script from "./EtatProduitsEntreePage.vue?vue&type=script&lang=ts"
export * from "./EtatProduitsEntreePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__